import axios, { AxiosRequestConfig } from "axios";
import qs from "qs";
import { _Base } from "../_Base";

export class Logos extends _Base {
  ENDPOINTROOT = process.env.REACT_APP_ROOT_T_API;
  async uploadLogo(data) {
    let url = this.ENDPOINTROOT + "logos/upload/";
    const reqParams: AxiosRequestConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      params: {
        ts: new Date().getTime(),
      },
      paramsSerializer: (params: any) => {
        return qs.stringify({ data });
      },
    };
    const response = await axios.post(url, data, reqParams);
    return response.data;
  }

  async proxyImage(data) {
    let url = this.ENDPOINTROOT + "logos/proxy-image/";

    const reqParams: AxiosRequestConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      params: {
        ts: new Date().getTime(),
      },
      paramsSerializer: (params: any) => {
        return qs.stringify({ data });
      },
    };
    try {
      const response = await axios.post(url, data, reqParams);
      return response.data;
    } catch (error) {
      throw new Error();
    }
  }
}
